import React from "react";
import { m } from "framer-motion";

const ValuesSection = () => {
  const containerAnimation = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        delay: 0.2,
        duration: 0.5,
        staggerChildren: 0.5,
      },
    },
  };

  const itemAnimation = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 0.7 } },
  };

  return (
    <section className="flex flex-col">
      <m.div
        className="container flex flex-col items-start justify-start gap-10 px-8 py-16"
        variants={containerAnimation}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
      >
        <div className="flex  flex-col items-start justify-center gap-6 self-stretch">
          <h2
            id="values"
            className="self-stretch p-0 text-4xl font-bold leading-[44px] text-primary-700"
          >
            Our Values
          </h2>
        </div>
        <div className="flex flex-col items-start justify-start gap-8 self-stretch">
          <div className="grid grid-cols-1 items-start justify-start gap-8 self-stretch md:grid-cols-2">
            <m.div
              className="flex flex-col items-start justify-center gap-4 self-stretch"
              variants={itemAnimation}
            >
              <div className="self-stretch text-2xl font-semibold leading-loose text-auto-black/80">
                Transparency
              </div>
              <ul className="self-stretch text-base font-medium leading-normal text-auto-black/60">
                <li className="self-stretch text-base font-medium leading-normal text-auto-black/60">
                  We believe in open and honest communication with our partners,
                  customers, and stakeholders.
                </li>
                <li className="self-stretch text-base font-medium leading-normal text-auto-black/60">
                  Transparency is the foundation of trust, and we strive to
                  provide clear insights into our operations.
                </li>
              </ul>
            </m.div>
            <m.div
              className="flex flex-col items-start justify-center gap-4 self-stretch"
              variants={itemAnimation}
            >
              <div className="self-stretch text-2xl font-semibold leading-loose text-auto-black/80">
                Commitment
              </div>

              <ul className="self-stretch pt-0 text-base font-medium leading-normal text-auto-black/60">
                <li className="self-stretch text-base font-medium leading-normal text-auto-black/60">
                  Our dedication to excellence drives us to fulfill our promises
                  and exceed expectations.
                </li>
                <li className="self-stretch text-base font-medium leading-normal text-auto-black/60">
                  We are committed to delivering high-quality products and
                  services consistently.
                </li>
              </ul>
            </m.div>
            <m.div
              className="flex flex-col items-start justify-center gap-4 self-stretch"
              variants={itemAnimation}
            >
              <div className="self-stretch text-2xl font-semibold leading-loose text-auto-black/70">
                Reliability
              </div>
              <ul className="self-stretch pt-0 text-base font-medium leading-normal text-auto-black/60">
                <li className="self-stretch text-base font-medium leading-normal text-auto-black/60">
                  Reliability is at the core of our operations. Our partners can
                  count on us for consistency and dependability.
                </li>
                <li className="self-stretch text-base font-medium leading-normal text-auto-black/60">
                  We take pride in building long-term relationships based on
                  trust and reliability.
                </li>
              </ul>
            </m.div>
            <m.div
              className="flex flex-col items-start justify-center gap-4 self-stretch"
              variants={itemAnimation}
            >
              <div className="self-stretch text-2xl font-semibold leading-loose text-auto-black/70">
                Sustainability
              </div>
              <ul className="self-stretch pt-0 text-base font-medium leading-normal text-auto-black/60">
                <li className="self-stretch text-base font-medium leading-normal text-auto-black/60">
                  We are committed to environmentally responsible practices,
                  ensuring our impact is positive and sustainable.
                </li>
                <li className="self-stretch text-base font-medium leading-normal text-auto-black/60">
                  Sustainability is woven into every aspect of our business,
                  from sourcing to production and distribution.
                </li>
              </ul>
            </m.div>
          </div>
        </div>
      </m.div>
    </section>
  );
};

export default ValuesSection;
